export const PANCHANG_CONTEXT_STRIP_HEIGHT = 34;

/**
 * Must render exactly `PANCHANG_CONTEXT_STRIP_HEIGHT` px: this placeholder
 * reserves the real strip's height so the swap cannot shift layout (rule 58).
 *
 * It is deliberately EMPTY. On performance-critical paths the interactive strip
 * waits for the first interaction or 30 s, and the grey "loading" pills this
 * used to draw read as a stuck loader under the header for that whole time
 * (b-content-07, b-hc-10, b-chat-09). The tinted band alone keeps the layout.
 *
 * Tailwind's JIT needs a literal, so the value cannot be interpolated from the
 * constant without an inline style. The two are pinned to agree by
 * `PanchangContextStripSkeleton.test.tsx` — change one and that test fails.
 */
export const PANCHANG_CONTEXT_STRIP_HEIGHT_CLASS = "h-[34px]";

export function PanchangContextStripSkeleton() {
  return <div aria-hidden="true" className={PANCHANG_CONTEXT_STRIP_HEIGHT_CLASS} />;
}
